<template>
  <div>
    <div class="searchbar-block">
      <h3>搜索条件 <span class="search-tip">{{searchTip}} &nbsp; <el-button type="text" v-if="searchTip.length>0" class="cl" @click="clearSearch">清除</el-button></span></h3>
      <div class="searchbar-box">
        <div class="price-block">
          <el-row>
            <el-col :span="12">
              <el-slider v-model="searchParams['2006']" range :min="0" :max="1330000" :step="10000" :format-tooltip="formatTooltip" :marks="marks">
              </el-slider>
            </el-col>
            <el-col :span="4">
              <!--/* v-model=""*/  -->
              <el-select v-model="searchParams['2024']" placeholder="请选择细分市场" filterable clearable multiple>
                <template>
                  <el-option v-for="item in searchOptions('2024')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select placeholder="按子车型名称搜索" v-model="searchParams['1003']" filterable clearable remote multiple autocomplete allow-create style="width:100%" @focus="onFocusFunc('1003')" :remote-method="getSearchCandidatesFunc">
                <template v-if="searchCandidates['1003']">
                  <el-option v-for="item in searchCandidates['1003']" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="search-more" v-show="openMore">
      <div class="searchbar-block">
        <h3>车辆属性</h3>
        <div class="searchbar-box">
          <el-row>
            <el-col :span="8">
              <span class="s-label">厂家</span>
              <el-select placeholder="请选择" v-model="searchParams['1001']" filterable clearable remote multiple allow-create @focus="onFocusFunc('1001')" :remote-method="getSearchCandidatesFunc">
                <template v-if="searchCandidates['1001']">
                  <el-option v-for="item in searchCandidates['1001']" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">品牌</span>
              <el-select placeholder="请选择" v-model="searchParams['1002']" filterable clearable multiple allow-create remote @focus="onFocusFunc('1002')" :remote-method="getSearchCandidatesFunc">
                <template v-if="searchCandidates['1002']">
                  <el-option v-for="(item, index) in searchCandidates['1002']" :key="index" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">系别</span>
              <el-select v-model="searchParams['2020']" placeholder="系别" filterable clearable multiple allow-create>
                <template>
                  <el-option v-for="item in searchOptions('2020')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="s-label">车身结构</span>
              <el-select v-model="searchParams['2023']" placeholder="车身结构" filterable clearable multiple allow-create>
                <template>
                  <el-option v-for="item in searchOptions('2023')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>

            </el-col>

            <el-col :span="8">
              <span class="s-label">来源</span>
              <el-select v-model="searchParams['2021']" placeholder="来源" filterable clearable multiple allow-create>
                <template>
                  <el-option v-for="item in searchOptions('2021')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>

            </el-col>

            <el-col :span="8">
              <span class="s-label">座椅数量</span>
              <el-select v-model="searchParams['2028']" placeholder="座椅数量" filterable clearable>
                <template>
                  <el-option v-for="item in searchOptions('2028')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>

            </el-col>
          </el-row>
        </div>
        <!--   <h3>车身尺寸</h3>
        <div class="searchbar-box">
          <el-row>
            <el-col :span="8">
              <span class="s-label">车身</span>
              <NumRange v-model="searchParams['2007']" />
            </el-col>
            <el-col :span="8">
              <span class="s-label">车宽</span>
              <NumRange v-model="searchParams['2008']" />
            </el-col>
            <el-col :span="8">
              <span class="s-label">车高</span>
              <NumRange v-model="searchParams['2009']" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="s-label">轴距</span>
              <NumRange v-model="searchParams['2010']" />
            </el-col>
            <el-col :span="8">
               <span class="s-label">座椅数量</span>
              <el-select v-model="market" placeholder="请选择">
                <el-option
                  v-for="item in [1, 2, 3, 4, 4, 5]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>  
            </el-col>
            <el-col :span="8"> <span class="s-label"></span> </el-col>
          </el-row>
        </div> -->
        <h3>动力参数</h3>
        <div class="searchbar-box">
          <el-row>
            <el-col :span="8">
              <span class="s-label">能源形式</span>
              <el-select v-model="searchParams['2027']" placeholder="能源形式" filterable clearable multiple allow-create>
                <template v-if="searchOptions('2027')">
                  <el-option v-for="item in searchOptions('2027')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">驱动方式（燃油）</span>
              <el-select v-model="searchParams['2029']" placeholder="驱动方式" filterable clearable multiple allow-create>
                <template v-if="searchOptions('2029')">
                  <el-option v-for="item in searchOptions('2029')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">驱动方式(新能源)</span>
              <el-select v-model="searchParams['2030']" placeholder="驱动方式" filterable clearable multiple allow-create>
                <template v-if="searchOptions('2030')">
                  <el-option v-for="item in searchOptions('2030')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
          </el-row>
          <!--  <el-row>
            <el-col :span="8">
              <span class="s-label">最大扭矩</span>
              <NumRange v-model="searchParams['2017']" />
            </el-col>
            <el-col :span="16">
              <span class="s-label">最大功率</span>
              <NumRange v-model="searchParams['2016']" />
            </el-col>
          </el-row> -->
        </div>
        <h3>新能源</h3>
        <div class="searchbar-box">
          <el-row>
            <el-col :span="8">
              <span class="s-label">电池生产厂商</span>
              <el-select placeholder="电池生产厂商" v-model="searchParams['2039']" filterable clearable allow-create multiple remote @focus="onFocusFunc('2039')" :remote-method="getSearchCandidatesFunc">
                <template v-if="searchCandidates['2039']">
                  <el-option v-for="item in searchCandidates['2039']" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">电池类型</span>
              <el-select v-model="searchParams['2037']" placeholder="电池类型" filterable clearable multiple allow-create>
                <template>
                  <el-option v-for="item in searchOptions('2037')" :key="item" :label="item" :value="item">
                  </el-option>
                </template>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">电池容量(kwh)</span>
              <NumRange v-model="searchParams['2018']" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="s-label">综合工况续航里程</span>
              <NumRange v-model="searchParams['2041']" />
            </el-col>
            <el-col :span="16">
              <span class="s-label">纯电动续航里程</span>
              <NumRange v-model="searchParams['2040']" />
            </el-col>
          </el-row>

        </div>
      </div>
      <div class="searchbar-block">
        <h3>装备</h3>
        <div class="searchbar-box">
          <el-row>
            <el-col :span="8">
              <span class="s-label">自动驾驶级别</span>
              <el-select v-model="autoDriveLvl" placeholder="请选择" clearable>
                <el-option v-for="item in autoDriveLvls" :key="item.val" :label="item.val" :value="item.val">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <span class="s-label">智能网联级别</span>
              <el-select v-model="intelNet" placeholder="请选择" clearable>
                <el-option v-for="item in intelNets" :key="item.val" :label="item.val" :value="item.val">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4"> &nbsp; </el-col>
            <el-col :span="4">
              <el-button type="text" @click="handleShowEquipFilter(true)">
                <!-- <svg-icon name="more_equip" size="32" /> --> 更多装备 ...
              </el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="eptags">
                <el-tag :key="tag.id" v-for="tag in includeTags" closable :disable-transitions="false" @close="handleClose(tag)" effect="light">{{ tag.name + ":" + tag.val }}</el-tag>
              </div>

              <div class="eptags">
                <el-tag :key="tag.id" v-for="tag in removeTags" closable :disable-transitions="false" @close="handleClose(tag)" effect="plain">{{ tag.name + ":" + tag.val }}</el-tag>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20"> &nbsp;</el-col>
            <el-col :span="4"> </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <span class="s-label">保存搜索条件</span>

              <el-select v-model="selectedSchemaID" placeholder="请选择结果集" @change="onSelectedSchemaChanged">
                <el-option label="新搜索方案" value="0"> </el-option>
                <el-option v-for="(item, index) in savedSearchSchemas" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-button @click="saveSearchSchema" style="margin-left: 6px">{{
                schemasButtonLabel
              }}</el-button>
            </el-col>
            <el-col :span="4"> </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="search-block-control">
      <el-button type="text" @click="onMore" class="arrow">
        <svg-icon :name="arrowName" size="32"></svg-icon>
      </el-button>

      <el-button icon="el-icon-search" type="success" @click="showParams" class="search-btn">
        搜索
      </el-button>
    </div>
    <el-dialog title="方案名称" :visible.sync="showNameInput" :center="false" :append-to-body="true">
      <span slot="dialog-title"> </span>
      <el-input v-model="schemaName"></el-input>
      <span slot="footer">
        <el-button @click="hideNameInput">取消</el-button>
        <el-button @click="confirmNameInput" type="primary">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showEquipFilter" :center="false" width="1100px" :append-to-body="true" title="装备筛选">
      <!--    <el-row>
        <el-col :span="12" style="text-align: right">
          <el-select
            placeholder="请选择结果集"
            @change="onSelectedSchemaChanged"
          >
            <el-option label="新搜索方案" value="0"> </el-option>
            <el-option
              v-for="(item, index) in savedEquipSearchSchemas"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
      </el-row> 
            <div style="border-top: 1px solid #eaeefb; margin: 2px 0"></div>
      -->

      <el-row>
        <el-col :span="12">
          <div class="leftbox">
            <div>
              <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select" clearable prefix-icon="el-icon-search">
                <el-select v-model="equipType" slot="prepend" placeholder="全部装备" style="width: 130px">
                  <el-option label="全部装备" value="全部"> </el-option>
                  <el-option v-for="item in this.equipCategories" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-input>
            </div>
            <div>
              <el-table :data="SelectionTags" style="width: 100%" height="450" id="equiptab">
                <el-table-column prop="name" label="装备名称" width="170">
                </el-table-column>
                <el-table-column prop="val" label="装备选项" min-width="175">
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button @click="handleContain(scope.$index, scope.row)" icon="el-icon-plus" circle :type="scope.row.status == 2 ? 'primary' : ''">
                    </el-button>
                    <el-button @click="handleRemove(scope.$index, scope.row)" icon="el-icon-minus" circle :type="scope.row.status == 4 ? 'primary' : ''">
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <p class="ttip"><strong>包含</strong> 如下装备 ...</p>
          <div class="containbox">
            <el-tag calss="tagitem" :key="tag.id" v-for="tag in includeTags" closable :disable-transitions="false" @close="handleClose(tag)">{{ tag.name + ":" + tag.val }}</el-tag>
          </div>
          <p class="ttip"><strong>排除</strong> 如下装备 ...</p>
          <div class="containbox">
            <el-tag :key="tag.id" v-for="tag in removeTags" closable :disable-transitions="false" @close="handleClose2(tag)">{{ tag.name + ":" + tag.val }}</el-tag>
          </div>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="handleShowEquipFilter(false)">返回</el-button>
        <!--  <el-button @click="saveSearchSchema">保存为搜索方案</el-button>
        <el-button @click="search" type="primary">搜索装备</el-button>-->
      </span>
    </el-dialog>

    <div v-if="false" style="padding: 6px 20px" v-loading="isLoading">
      <slot name="defaultContent"></slot>
    </div>

    <div class="clear-fix"></div>
    <el-card v-loading="isLoading" style="margin: 10px 10px 0">
      <el-tabs type="card" @tab-click="handleSelectTab" v-model="currentTabName">
        <el-tab-pane label="搜索结果" name="tabSearchResult">
          <span slot="label">
            搜索结果
            <!--<el-badge class="mark" :value="searchResultCount" /> -->
          </span>
          <VehicleSearchResult @ActiveTab="activeTabByName" :showSelectionButton="!disableResultTab" :resultExclusiveChoice="resultExclusiveChoice">
            <slot name="resultButton" slot="resultButton"></slot>
          </VehicleSearchResult>
        </el-tab-pane>
        <el-tab-pane name="tabSelectionResult" v-if="!disableResultTab">
          <span slot="label">
            已选择列表
            <el-badge class="mark" :value="selectionResultCount" />
          </span>
          <VehicleSelectionResult :moduleName="moduleName">
            <slot></slot>
          </VehicleSelectionResult>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import VehicleSearchResult from "@/components/common/SearchResult.vue";
import VehicleSelectionResult from "@/components/common/SelectionResult.vue";
import NumRange from "@/components/common/NumRange.vue";
import ApiUrl from "../../store/apiurl";
import GUID from "../../store/guid";
import { join } from "path";
import About from "../../views/about.vue";
import SvgIcon from "../SvgIcon.vue";
import { clearTimeout } from "timers";
export default {
  props: {
    showMore: {
      type: Boolean,
      default: false,
    },
    moduleName: {
      type: String,
      required: true,
    },
    showCommonAdvancedSearch: {
      type: Boolean,
      default: true,
    },
    disableResultTab: {
      type: Boolean,
      default: false,
    },
    resultExclusiveChoice: {
      type: Boolean,
      default: false,
    },
    showEquipSearchButton: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NumRange,
    SvgIcon,
    VehicleSearchResult,
    VehicleSelectionResult,
  },
  data() {
    return {
      isFixed: false,
      offsetTop: 0,
      showEquips: [],
      checkList: [],

      showEquipFilter: false,
      openMore: this.showMore,
      xfsc: [],
      chartOption: {},

      marks: {
   
        20000: "<2万",
       
        
          150000: {
            style: {
              color: '#1989FA'
            },
            label: this.$createElement('strong', '15万')
          },
          300000: '30万',
          500000: '50万',
          800000: '80万',
      
          1200000: '100万+',

      
      
      },
      market_options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      market: "",
      equipType: "全部",
      keyword: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近二个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 2);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      showNameInput: false,
      currentSmartSelectId: "all",
      schemaName: "",
      showSettings: false,
      // searchParams: {},
      expandedConditions: [],
      selectedConditions: [], // 置入的条件
      selectedSchemaID: "0",
      searchCandidates: {},
      selectedType: "全部",
      selectedTypeId: "1000",
      smartKeywords: [],
      timeout: null,
      showAdvancedSearch: false,
      currentTabName: "tabSearchResult",
      recentScheme: ["1", "2"],
      firstSearch: false,
    };
  },

  computed: {
    ...mapGetters("commonsearch", [
      "currentSearchSchema",
      "savedSearchSchemas",
      "searchParams",
      "searchSchema",
      "searchCategories",
      "commonSearchKeywords",
      "hasSelectionResult",
      "hasSearchResult",
      "selectionResult",
      "searchResultModel",
      "searchResult",
      "currentModuleName",
    ]),
    ...mapGetters("searchequip", [
      "savedEquipSearchSchemas",
      "equipOptions",
      "equipCategories",
    ]),
    ...mapState({
      isLoading: (state) => state.loadingCount > 0,
    }),


    searchTip() {
      if (this.searchParams.length == 0)
        return '';

      if (JSON.stringify(this.searchParams) == "{}")
        return '';
      var len = 0;
      var str = '';
      for (let idx in this.searchParams) {
        if (idx == '2006') continue;
        let x = this.searchParams[idx];
        if (x == '') {
          continue;
        }


        if (Array.prototype.isPrototypeOf(x)) {
          if (x.length == 0) {
            continue;
          }
          len += 1;
          for (let s of x) {
            str += s + ' 、';
          }

        }
      }
      if (len == 0)
        return '';

      var ret = `已选${len}个条件.. ${str}`;
      if (ret.length > 15)
        return ret.substring(0, 30) + '...';

      return ret;

    },
    schemasButtonLabel() {
      return this.selectedSchemaID == "0" ? "保存方案" : "更新方案";
    },
    autoDriveLvl: {
      get: function () {
        var ls = this.autoDriveLvls;
        for (var x of this.includeTags) {
          for (var y of ls) {
            if (y.id == x.id) {
              return y.val;
            }
          }
        }
        return "";
      },
      set: function (newVal) {
        var ls = this.autoDriveLvls;
        for (var z of ls) {
          if (z.val == newVal) {
            z.status = 2;
          } else {
            z.status = 1;
          }
        }
      },
    },
    intelNet: {
      get: function () {
        var ls = this.intelNets;
        for (var x of this.includeTags) {
          for (var y of ls) {
            if (y.id == x.id) {
              return y.val;
            }
          }
        }
        return "";
      },
      set: function (newVal) {
        var ls = this.intelNets;
        for (var z of ls) {
          if (z.val == newVal) {
            z.status = 2;
          } else {
            z.status = 1;
          }
        }
      },
    },
    arrowName() {
      return this.openMore ? "arrow_up" : "arrow_down";
    },
    searchOptions(id) {
      return function (id) {
        if (!this.searchSchema || this.searchSchema == "") {
          return [];
        } else {
          return this.searchSchema.find((item) => item.id === id).options;
        }
      };
    },

    includeTags() {
      return this.equipOptions.filter((item) => {
        return item.status == 2;
      });
    },
    removeTags() {
      return this.equipOptions.filter((item) => {
        return item.status == 4;
      });
    },

    SelectionTags() {
      return this.equipOptions.filter((item) => {
        return (
          item.name != "自动驾驶级别" &&
          item.name != "智能网联" &&
          (this.keyword == "" ||
            item.val.indexOf(this.keyword) > -1 ||
            item.name.indexOf(this.keyword) > -1) &&
          (this.equipType == "全部" || item.tag == this.equipType)
        );
      });
    },
    SelectionTagVals() {
      return this.SelectionTags.map((item) => item.name + ":" + item.val);
    },
    autoDriveLvls() {
      return this.equipOptions.filter((item) => {
        return item.name == "自动驾驶级别";
      });
    },
    intelNets() {
      return this.equipOptions.filter((item) => {
        return item.name == "智能网联";
      });
    },
    selectionResultCount() {
      return this.selectionResult.length;
    },
    searchResultCount() {
      return this.searchResult.length;
    },
  },
  methods: {
    ...mapActions("commonsearch", [
      "saveCurrentSearchSchema",
      "createOrUpdateSearchSchema",
      "selectSavedSearchSchema",
      "initSavedSearchSchema",
      "doSearch",
      "queryLine",
      "getSearchSchemaAsync",
      "getCommonSearchKeywordAsync",

    ]),

    ...mapActions("searchequip", [
      "saveEquipSearchSchema",
      "queryEquipList",

      "loadEquipSearchSchema",
      "selectEquipSearchSchema",
    ]),
    ...mapMutations("commonsearch", [
      "clearCurrentSearchSchema",
      "setSearchParams",
      "setDefauleSearchSchema",
      "setCurrentModuleName",
    ]),
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //console.log(scrollTop);
      if (scrollTop >= this.offsetTop) {
        if (!this.isFixed) {
          var w = document.querySelector('.x-subnav').offsetWidth;
         
          document.querySelector('.x-subnav').setAttribute("style", "position:fixed;top:-40px;padding-top:40px;width:"+w+"px;");
          this.isFixed = true;
        }


      } else {

        if (this.isFixed) {
          document.querySelector('.x-subnav').setAttribute("style", "position:initial;");
          this.isFixed = false;
        }

      }
    },
    setEquipStatus(ids, status) {
      for (var id of ids) {
        var cur = this.equipOptions.find((item) => {
          return item.id == id;
        });
        if (!cur) continue;
        cur.status = status;
      }
    },
    handleShowEquipFilter(visible) {
      this.showEquipFilter = visible;
    },

    handleContain(index, row) {
      row.status = 2;
      console.log(index, row);
    },
    handleRemove(index, row) {
      row.status = 4;
      console.log(index, row);
    },
    handleSelectTab(tab, event) {
      console.log(tab, event);
    },
    handleClose(tag) {
      tag.status = 1;
    },
    handleClose2(tag) {
      tag.status = 1;
    },
    formatTooltip(val) {
 
      if (val < 20000) {
        return "<2万";
      } else if (val > 2000000) {
        return "200万+";
 
      }
      return (val / 10000) + '万';
    },
    formatPrice(val) {
      if (val < 10) {
        return 0;
      }
      if (val >= 120) {
        return 200000000;
      }
      return (val - 10 + 2) * 10000;
    },
    onMore() {
      this.openMore = !this.openMore;
      if (this.openMore) {

        this.offsetTop = document.querySelector('.x-subnav').offsetTop;
        window.addEventListener('scroll', this.handleScroll);

      } else {
        //this.isFixed = false;
        document.querySelector('.x-subnav').setAttribute("style", "position:initial;");
        // 离开页面 关闭监听 不然会报错
        window.removeEventListener('scroll', this.handleScroll);
      }
    }, // 隐藏名称输入
    hideNameInput() {
      this.showNameInput = false;
    },
    showParams() {
      //  console.log(this.searchParams);
 
       if(this.searchTip=='')
       {
         this.$confirm('您没有选择搜索条件、返回结果比较缓慢！ 确定要搜索全部车款吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              this.postSearch();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消搜索'
          });  
           
        });

     
      }  else{
        this.postSearch();
      }
  
      
    
    },
    postSearch(){
  var postData = {
        equipParams: {
          include: this.includeTags.map((x) => x.id),
          exclude: this.removeTags.map((x) => x.id),
        },
        searchParams: this.searchParams,
      };

      // alert(JSON.stringify(postData));
      this.firstSearch = true;
      this.queryLine(postData);
      this.handleShowEquipFilter(false);

    },
    onSaved(res) {
      this.$message({
        message: res ? "已保存" : "保存失败",
        duration: 2000,
      });
    },
    // 确认名次输入
    confirmNameInput() {
      if (this.schemaName) {
        var postData = {
          equipParams: {
            include: this.includeTags.map((x) => x.id),
            exclude: this.removeTags.map((x) => x.id),
          },
          searchParams: this.searchParams,
        };
        this.updateEquipSchema(postData.equipParams);
        var key = new GUID().newGUID();
        this.createOrUpdateSearchSchema({
          schemaId: key,
          name: this.schemaName,
          module: this.moduleName,
          jsonData: postData,
          action: "add",
          cb: this.onSaved,
        });
        this.hideNameInput();
      }
    },

    mouseEnter(i) {
      this["currentClass" + i] = "grid-hover";
    },
    mouseLeave(i) {
      this["currentClass" + i] = "";
    },

    activeTabByName(name) {
      this.currentTabName = name;
    },
    // 搜索
    search() {
    
      this.doSearch(this.searchParams);
      this.hideDialog(); 
    },
    clearSearch() {
      for (let idx in this.searchParams) {
        if (idx == '2006') continue;
        this.searchParams[idx] = [];
      }

    },
    // 设置搜索条件
    showSettingsDialog() {
      this.showSettings = true;
    },
    updateEquipSchema() {
      this.currentSearchSchema.equipParams = {};
    },
    // 保存方案
    saveSearchSchema(eps) {
      this.currentSearchSchema["searchParams"] = eps;

      if (!this.currentSearchSchema.name) {
        this.showNameInput = true;
      } else {
        var postData = {
          equipParams: {
            include: this.includeTags.map((x) => x.id),
            exclude: this.removeTags.map((x) => x.id),
          },
          searchParams: this.searchParams,
        };
        this.updateEquipSchema(postData.equipParams);
        this.createOrUpdateSearchSchema(
          {
            schemaId: this.currentSearchSchema.id,
            name: this.currentSearchSchema.name,
            module: this.moduleName,
            jsonData: postData,
            action: "update",
            cb: this.onSaved,
          },
          "search"
        );
      }
    },

    onFocusFunc(opt) {
      // alert(opt);
      this.currentSmartSelectId = opt;
    },
    // 获取联想
    async getSearchCandidatesFunc(query, str) {
      try {
        const resp = await this.$axios.post(
          ApiUrl.salesanalysis.getsmartsearchkeyword,
          { id: this.currentSmartSelectId, keyword: query }
        );
        console.log(resp);
        this.timeout && clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          //  console.log(resp.data.result);
          //   cb(resp.data.result);
          var keys = [];
          for (var v in resp.data.result) {
            keys.push(resp.data.result[v].value);
          }
          this.$set(this.searchCandidates, this.currentSmartSelectId, keys);
          // return (keyword) => { }
          this.timeout = null;
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    },
    //预载入
    async loadSearchCandidatesFunc(smartSelectId, keyword) {
      try {
        var key = keyword == undefined ? "" : keyword;
        const resp = await this.$axios.post(
          ApiUrl.salesanalysis.getsmartsearchkeyword,
          { id: smartSelectId, keyword: key }
        );
        var keys = [];
        for (var v in resp.data.result) {
          keys.push(resp.data.result[v].value);
        }
        this.$set(this.searchCandidates, smartSelectId, keys);
      } catch (e) {
        console.log(e);
      }
    },
    clearEquipOptions() {
      for (var x of this.equipOptions) {
        x.status = 1;
      }
    },
    // 方案选择变化
    onSelectedSchemaChanged(val) {
      this.clearEquipOptions();
      if (val === "0") {
        this.clearCurrentSearchSchema();
        this.setDefauleSearchSchema();
        this.setSearchParams({});
      } else {
        this.selectSavedSearchSchema(val);

        this.setSearchParams(this.currentSearchSchema.searchParams);

        let es = this.currentSearchSchema.equipParams;
        if (!es) return;

        //设置方案中的装备选项
        this.setEquipStatus(es.include, 2);
        this.setEquipStatus(es.exclude, 4);
      }
    },
    async loadAll() {

      this.getSearchSchemaAsync();
      this.getCommonSearchKeywordAsync();
      await this.initSavedSearchSchema({ moduleName: this.moduleName });
      //await this.loadEquipSearchSchema();
      var prekeys = ["1001", "1002", "2024"];
      for (let item of prekeys) {
        await this.loadSearchCandidatesFunc(item);
      }

      this.getCommonSearchKeywordAsync();

      if (this.equipOptions == null || this.equipOptions.length == 0) {
        await this.queryEquipList();
      }
    },
    chooseEquip() {
      //  alert(JSON.stringify(this.searchParams));
      //  this.showCommonSearch = false;
      this.handleShowEquipFilter(true);
    },
    clearLineSearch() {
      this.clearCurrentSearchSchema();
      this.$message({
        message: "已清理",
        duration: 2000,
      });
    },
  },

  watch: {

    moduleName(newValue) {
      this.setCurrentModuleName(newValue);
    },
    showMore(newValue) {
      this.openMore = newValue;
    },
    searchParams: function (newVal) {
      console.log(newVal);
      // alert(JSON.stringify(newVal));


    },
    searchResult(newValue) {
      if (newValue && newValue.length > 0) {
        this.openMore = false;
      }

    },
    currentSearchSchema: function (newVal) {
      /* let newParams = {};
      if (newVal && Array.isArray(newVal.cols)) {
        for (let k in this.searchParams) {
          if (
            newVal.cols.findIndex((item) => {
              return item.id === k;
            }) > -1
          ) {
            newParams[k] = this.searchParams[k];
          }
        }
      }
      this.setSearchParams(newParams); // ;
      if (newVal.id) {
        this.selectedSchemaID = newVal.id;
      } else {
        this.selectedSchemaID = "0";
      }*/
    },
  },
  created() { },
  destroyed() {

    // 离开页面 关闭监听 不然会报错
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    //   var key = new GUID().newGUID();
    //alert(key);
    this.loadAll();

    let searchType = this.$route.query.searchType;




  },
};
</script>

<style scoped>
.el-row {
  text-align: left;
  margin-bottom: 20px;
}
.el-col {
  padding-left: 20px;
}
.search-block-control {
  background-color: #fff;
  text-align: center;
  margin-top: -2px;
  color: #d3dce6;
  cursor: pointer;
  position: relative;
  margin: -2px 10px 10px;
  padding: 0;
  border: rgba(0, 0, 0, 0.1) solid 1px;
  border-top: none;
}

.equip-main {
  padding: 80px 60px;
}
.grid-hover {
  color: rgb(0, 162, 255);
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.2);
}
.grid-content {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px;
  min-height: 260px;
  cursor: pointer;
}
.grid-content .icon {
  margin-top: 3em;
}
.grid-content .icon i {
  font-size: 3em;
}
.search-wrapper {
  line-height: 24px;
}
.label {
  line-height: 40px;
}
.leftbox,
.containbox,
.removebox {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 8px;
}
.ttip {
  padding-left: 20px;
}
.el-tag + .el-tag {
  margin-right: 30px;
  margin-top: 10px;
}
.containbox,
.removebox {
  margin-left: 20px;
  min-height: 190px;
}
.el-table::before {
  height: 0;
}

#equiptab .el-table__body-wrapper {
  overflow-x: hidden !important;
}
#equiptab .el-dialog__body {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.eptags {
  display: flex;
  margin-left: 8%;
  width: 80%;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.eptags span {
  margin: 10px 20px;
  width: calc(var(--itemWidth));
  margin-left: calc((100% - var(--itemWidth) * var(--n)) / (var(--n) + 1));
}
button.arrow:hover {
  color: #ffad53;
}
.search-btn {
  position: absolute;
  right: 42px;
  bottom: 25px;
}
.price-block  .el-slider__marks .el-slider__marks-text{
  font-size:12px !important;
}
</style>
